import { Link } from "react-router";
import React from 'react'
import { SignInWithPasswordForm } from "../../components/forms/signInWithPasswordForm";
import { SignInTabNav } from "./nav";
import { useSignInContext } from "./context";

export function SignInWithPassword() {
  const {onLoginSuccess} = useSignInContext()

  return <div className='row justify-content-center mt-4 sign-in sign-in__with-password'>
    <div className='col-12 col-lg-6'>
      <h1>Sign In</h1>
      <SignInTabNav />
      <SignInWithPasswordForm onLoginSuccess={(s) => { onLoginSuccess?.(s) }} />
      <hr />
      <div className='d-flex'>
        <span>&nbsp;</span>

        <Link to='/forgotPassword' className='ms-auto'>Forgot password?</Link>
      </div>
    </div>
  </div>
}
